import React from 'react';
import { AppBar as MuiAppBar, Toolbar, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import Logo from '../../assets/Alerta Normativa-logo2026-claro.png';

const AppBarPublico = () => {
    return (
        <MuiAppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: '#f8f9fa' }}>
            <Toolbar sx={{ justifyContent: 'left' }}>
                <Box sx={{ display: 'flex', alignItems: 'left' }}>
                    <Link style={{ textDecoration: 'none', color: 'inherit' }} to="/">
                        <img 
                            src={Logo} 
                            alt="Alerta Normativa" 
                            style={{ 
                                height: '50px', 
                                display: 'flex',
                                cursor: 'pointer'
                            }} 
                        />
                    </Link>
                </Box>
            </Toolbar>
        </MuiAppBar>
    );
};

export default AppBarPublico;